exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.lesson_preview_modal__preview-container--2Xl8t {\n    height: 500px;\n    border: 1px solid #eaeef1;\n    display: flex;\n}\n", ""]);

// exports
exports.locals = {
	"preview-container": "lesson_preview_modal__preview-container--2Xl8t"
};